import { Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { PLANS_MODE, FRONT_PLANS } from 'Constants/plans';
import * as Styled from './styles';

const SuccessPurchase = ({ plan }: { plan: FRONT_PLANS | string }): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const logoKey = PLANS_MODE[plan];
  return (
    <Styled.SuccessContainer direction="column" gap="dimension_32" mb="fds_size_16">
      <Styled.BackgroundImage plan={logoKey}>
        <img src={`${TAXDOWN_ASSETS_DOMAIN}/mx/${logoKey}.png`} alt={logoKey} />
      </Styled.BackgroundImage>
      <Styled.TextContainer align="center">
        <Text type="headline" size="XS_L_M" color="dark" align="center">
          {t('Filing.purchase.success')}
          <img
            src={`${TAXDOWN_ASSETS_DOMAIN}/plans/smart-filter/v2/${logoKey}_logo.svg`}
            alt={`${logoKey}_logo`}
          />
          {plan}
        </Text>
      </Styled.TextContainer>
    </Styled.SuccessContainer>
  );
};

export default SuccessPurchase;
